export const DATA_TABLE_SYSTEM_COLUMN_TYPE_MAP = {
    id: 'number',
    createdAt: 'date',
    updatedAt: 'date',
};
export const DATA_TABLE_SYSTEM_COLUMNS = Object.keys(DATA_TABLE_SYSTEM_COLUMN_TYPE_MAP);
export const DATA_TABLE_SYSTEM_TESTING_COLUMN = 'dryRunState';
//# sourceMappingURL=data-table.types.js.map